document.addEventListener('DOMContentLoaded', function() {
    // Find all tab layouts on the page
    const tabLayouts = document.querySelectorAll('.tab-layout');
    
    // Initialize each tab layout independently
    tabLayouts.forEach(tabLayout => {
        const tabLinks = tabLayout.querySelectorAll('.tab-nav a');
        const tabSections = tabLayout.querySelectorAll('.tab-section');
        
        // Show first tab by default for this layout
        if (tabSections.length > 0) {
            tabSections[0].classList.add('active');
            if (tabLinks.length > 0) {
                tabLinks[0].classList.add('active');
            }
        }
        
        // Add click event listeners for this layout
        tabLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                // Check if link has 'notab' class - if so, allow normal navigation
                if (this.classList.contains('notab')) {
                    return; // Allow default navigation behavior
                }

                e.preventDefault();

                tabLayout.classList.remove('active');
                
                const targetId = this.getAttribute('href').substring(1);
                const targetSection = tabLayout.querySelector('#' + targetId);
                
                if (!targetSection || targetSection.classList.contains('active')) {
                    return; // Already active or invalid target
                }

                tabLayout.classList.add('active');
                
                // Find currently active section in this layout
                const currentActiveSection = tabLayout.querySelector('.tab-section.active');
                
                // Remove active class from all tabs in this layout
                tabLinks.forEach(l => l.classList.remove('active'));
                
                // Add active class to clicked tab
                this.classList.add('active');
                
                if (currentActiveSection) {
                    // Add sliding-out class to current section
                    currentActiveSection.classList.add('sliding-out');
                    
                    // Wait for slide-out animation to complete
                    setTimeout(() => {
                        // Remove active and sliding-out classes from all sections in this layout
                        tabSections.forEach(s => {
                            s.classList.remove('active', 'sliding-out');
                        });
                        
                        // Add active class to target section
                        targetSection.classList.add('active');
                    }, 250); // Half of the transition duration
                } else {
                    // No current active section, just show the target
                    tabSections.forEach(s => s.classList.remove('active'));
                    targetSection.classList.add('active');
                }
            });
        });


        if (tabLayout.querySelector('.close-tab-layout')) {
            tabLayout.querySelector('.close-tab-layout').addEventListener('click', function(e) {
                e.preventDefault();
                tabLayout.classList.remove('active');
            });
        }
    });
});